<div class="page-container-full" [class.fullscreen-mode]="isFullscreen()">
	<div class="clean-header-minimal p-2">
		@if (!isPublic()) {
			<div class="back-link-minimal" (click)="goBack()">
				<i class="bi bi-arrow-left"></i>
				Torna indietro
			</div>
		}
	</div>

	@if (signatureCompleted()) {
		<div class="d-flex flex-column align-items-center justify-content-center w-100 px-4 text-center" style="height: calc(100vh - 60px); background: #fff;">
			<div class="success-screen-mobile">
				<i class="bi bi-check-circle-fill" style="font-size: 5rem; color: #27ae60;"></i>
				<h2 class="mt-4 mb-3" style="font-size: 1.8rem; color: #2C3E50; font-weight: 700;">Pratica conclusa con successo</h2>
				<p style="color: #6c757d; font-size: 1.1rem; line-height: 1.5;">Grazie! La tua firma è stata registrata correttamente. Puoi chiudere questa pagina.</p>
			</div>
		</div>
	} @else {
		<div class="doc-viewer-area-clean">
		@if (loadingPage()) {
			<div class="viewer-status-center">
				<div class="spinner-border spinner-teal"></div>
			</div>
		} @else if (pageUrls().length > 0) {
			<div class="doc-canvas-container-continuous" (scroll)="onScroll($event)">
				@for (url of pageUrls(); track i; let i = $index) {
					<div class="doc-canvas-wrapper-page" [id]="'page-' + (i + 1)" [style.width.%]="zoomLevel() * 100">
						<img [src]="url" alt="Pagina documento" class="doc-page-img-clean" style="width: 100%; height: auto; transition: width 0.2s ease-out; display: block; margin: auto;" />

						<div class="signature-overlay" style="width: 100%">
							@for (field of getFieldsForPage(i + 1); track field.signatureFieldID) {
								<div
									[id]="'field-' + field.signatureFieldID"
									class="sign-field"
									[class.required]="field.required"
									[class.signed]="field.firmato"
									[style.width.%]="field.w"
									[style.height.%]="field.h"
									[style.left.%]="field.y"
									[style.bottom.%]="field.x"
									(click)="signField(field)">
									Clicca per firmare
								</div>
							}
						</div>
					</div>
				}
			</div>
		} @else {
			<div class="viewer-status-center">Nessuna anteprima disponibile</div>
		}
	</div>

	<div class="doc-controls-minimal py-2">
		<div class="controls-group">
			<button class="doc-nav-btn-minimal" (click)="prevPage()" [disabled]="!canPrev()">
				<i class="bi bi-chevron-left"></i>
			</button>
			<button class="doc-nav-btn-minimal" (click)="nextPage()" [disabled]="!canNext()">
				<i class="bi bi-chevron-right"></i>
			</button>
		</div>

		<button class="doc-nav-btn-minimal" (click)="toggleFullscreen()">
			<i class="bi" [class.bi-arrows-angle-expand]="!isFullscreen()" [class.bi-arrows-angle-contract]="isFullscreen()"></i>
		</button>

		<div class="controls-group">
			<button class="doc-nav-btn-minimal" (click)="zoomOut()"><i class="bi bi-zoom-out"></i></button>
			<button class="doc-nav-btn-minimal" (click)="zoomIn()"><i class="bi bi-zoom-in"></i></button>
		</div>
	</div>

	@if (showDettaglioSheet()) {
		<div class="doc-details-sheet" [class.closing]="isSheetClosing()">
			<div class="sheet-header">
				<div class="sheet-left">
					<i class="bi bi-x-lg sheet-close" (click)="closeDettaglio()"></i>
					<div class="sheet-title">{{ docName() }}</div>
				</div>

				<div class="sheet-pagination">
					<i class="bi bi-chevron-left" [class.disabled]="!canPrev()" (click)="prevPage()"></i>
					<span>{{ currentPage() }} / {{ totalPages() }}</span>
					<i class="bi bi-chevron-right" [class.disabled]="!canNext()" (click)="nextPage()"></i>
				</div>
			</div>

			<div class="sheet-body">
				@for (doc of praticaDetail()?.documents; track doc.documentID; let docIdx = $index) {
					<div class="doc-group mb-4">
						<div class="doc-group-title small fw-bold mb-3 d-flex align-items-center gap-2 text-muted">
							<i class="bi bi-file-earmark-text"></i>
							{{ doc.fileName }}
						</div>
						<div class="page-grid">
							@for (page of getPagesForDocument(docIdx); track page.globalPage) {
								<div class="page-card" [class.active]="currentPage() === page.globalPage" (click)="goToPageSelect(page.globalPage)">
									@if (pagesWithSignature().has(page.documentID + '-' + page.localPage)) {
										<div class="page-card-icon">
											<i class="bi bi-pencil"></i>
										</div>
									}

									<div class="page-card-img-placeholder">
										@if (getUrlMiniaturaPagina(page.globalPage)) {
											<img [src]="getUrlMiniaturaPagina(page.globalPage)" class="page-thumbnail" />
										} @else {
											<i class="bi bi-file-earmark-text"></i>
										}
									</div>
									<div class="page-card-number">{{ page.localPage }}</div>
								</div>
							}
						</div>
					</div>
				}
			</div>
		</div>
	}

	@if (showFirmaMultipla()) {
		<div class="px-3 py-2 border-top">
			<div class="form-check form-switch mb-2">
				<input class="form-check-input" type="checkbox" id="firmaMultiplaSwitch" [checked]="firmaMultipla()" (change)="firmaMultipla.set($any($event.target).checked)">
				<label class="form-check-label fw-semibold small" for="firmaMultiplaSwitch">Firma Multipla</label>
			</div>
			@if (firmaMultipla()) {
				<div class="alert alert-warning py-2 px-3 small mb-0">
					<strong>Attenzione</strong><br>
					Stai per firmare la pratica in modo automatico. Proseguendo, confermi di accettare integralmente il contenuto dei documenti e dichiari di assumerti ogni responsabilità derivante dalla loro firma.
				</div>
			}
		</div>
	}
	<div class="action-bar-clean">
		<button class="action-btn-clean action-danger" (click)="openRifiutaModal()">
			<i class="bi bi-x-square"></i>
			<span>RIFIUTA</span>
		</button>
		<button class="action-btn-clean action-secondary" [class.active]="showDettaglioSheet() && !isSheetClosing()" (click)="toggleDettaglio()">
			<i class="bi" [class.bi-clipboard]="!showDettaglioSheet() || isSheetClosing()" [class.bi-clipboard-fill]="showDettaglioSheet() && !isSheetClosing()"></i>
			<span>DETTAGLIO</span>
		</button>
		<button class="action-btn-clean action-sign" (click)="goToFirma()" [disabled]="isAllSigned() || isAtFirstUnsignedPage()">
			<i class="bi bi-pencil"></i>
			<span>FIRMA</span>
		</button>
		<button class="action-btn-clean action-success" (click)="conferma()" [disabled]="!allRequiredSigned() || loadingAction()">
			<i class="bi bi-check2-square"></i>
			<span>CONFERMA</span>
		</button>
	</div>
	}
	@if (loadingAction()) {
		<div class="loading-overlay-fixed">
			<div class="spinner-border" role="status"></div>
			<span>Firma in corso...</span>
		</div>
	}
</div>
